// extracted by mini-css-extract-plugin
module.exports = {"subGroup":"CartCard-SubGroup-module--sub-group--3nBfB","border":"CartCard-SubGroup-module--border--38FMo"};